
$(document).ready(function () {
  var total = 0;

  $('.js_order-item').each(function (i, item) {
    var input = $(item).find('input.counter');
    var value = parseInt(input.val());
    var productId = $(item).data('productid');
    var basePrice = $('#basePrice' + productId).val();
    var totalProduct = value * parseInt(basePrice);


    $(item).find('span.js_price').text(totalProduct.toFixed(2) + ' '+CART_VARS.currencyName)

    total += totalProduct;

  });

  $('.js_total').text(total.toFixed(2) + ' '+CART_VARS.currencyName);
});

$(document).ready(function(){
  $('.down_count').on('click', function(e) {
    e.preventDefault();
    var input = $(this).closest('div').find('input');
    var value = parseInt(input.val());
    var productId = $(this).parent().parent().parent().data('productid');
    var basePrice = $('#basePrice' + productId).val();
    var formattedPrice;
    var priceContainer = $(this).parent().parent().find('span.js_price');



    if(value <= 1) return;

    value = value - 1;

    input.val(value);

    formattedPrice = basePrice * value;
    priceContainer.text(formattedPrice.toFixed(2) + ' '+CART_VARS.currencyName);
    getTotal();
  });

  $('.up_count').on('click', function(e) {
    e.preventDefault();
    var input = $(this).closest('div').find('input');
    var value = parseInt(input.val());
    var productId = $(this).parent().parent().parent().data('productid');
    var basePrice = $('#basePrice' + productId).val();
    var formattedPrice;
    var priceContainer = $(this).parent().parent().find('span.js_price');



    value = value + 1;

    input.val(value);

    formattedPrice = basePrice * value;
    priceContainer.text(formattedPrice.toFixed(2) + ' '+CART_VARS.currencyName);
    getTotal();
  });

  // on input change - price change
  $('.counter').change(function () {
    var val = $(this).val();
    var productId = $(this).parent().parent().parent().data('productid');
    var basePrice = $('#basePrice' + productId).val();
    var priceContainer = $(this).parent().parent().find('span.js_price');

    if(val <= 0) {
      $(this).val(1);
      priceContainer.text(basePrice + '.00 '+CART_VARS.currencyName);
      return;
    }

    var formattedPrice = basePrice * val;

    priceContainer.text(formattedPrice.toFixed(2) + ' '+CART_VARS.currencyName);

    getTotal();
  });

  function getTotal() {
     var totalPrice = 0;
     var totalContainer = $('.js_total');

    $('.js_price').each(function(){
      var textPrice = $(this).text();
      var numPrice = parseFloat(textPrice);

      totalPrice += numPrice;
    });

    totalContainer.text(totalPrice.toFixed(2) + ' '+CART_VARS.currencyName);
  };
});


$(document).ready(function () {

  $.ajaxSetup({
    headers: {
      'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
  });

  $('.order-btn').click(function (e) {

    var ajaxUrl = $('input#routeOrder').val();
    var user_id = $('input#userID').val();
    var items = $('.js_order-item');
    var products = [];

    items.each(function (i, item) {
      var name =  $(item).find('span.js_name').text();
      var quantity = $(item).find('input.counter').val();
      var product_id = item.getAttribute('data-productid');
      var type = item.getAttribute('data-type');

      var orderItem = {
          name: name,
          quantity: quantity,
          product_id: product_id,
          type: type
      };


      products.push(orderItem);
    });

    var orderInfo = {
      products: products,
      user_id: user_id
    };


    $.ajax({
      type: 'POST',
      url: ajaxUrl,
      data: orderInfo,
      success: function (data) {
        window.location.replace(data);

      }
    });
  });
});

if (navigator.appName == 'Microsoft Internet Explorer' ||  !!(navigator.userAgent.match(/Trident/) || navigator.userAgent.match(/rv:11/)) || (typeof $.browser !== "undefined" && $.browser.msie == 1)) {
  $('main').addClass('noFlex');
}

$(document).ready(function(){
  var emailInput = $('#buyerEmail');

  $('#deliveryConfirm').click(function (e) {
    var emailValue = $(emailInput).val();
    var autoCheckboxChecked = $('#autocompleteCheck').is(':checked');

    if(!localStorage.getItem(emailValue) && autoCheckboxChecked) {

      var deliveryData = {
        deliveryAddress: $('#buyerAddress').val(),
        deliveryCity:    $('#buyerCity').val(),
        deliveryName:    $('#buyerName').val(),
        deliveryPhone:   $('#buyerPhone').val(),
        deliveryZip:     $('#buyerZip').val()
      };

      localStorage.setItem(emailValue, JSON.stringify(deliveryData));
    }

  });

  emailInput.on('blur', function () {
    var emailValue = $(emailInput).val();

    if(localStorage.getItem(emailValue)) {
      var userData = JSON.parse(localStorage.getItem(emailValue));

      $('#buyerAddress').val(userData.deliveryAddress);
      $('#buyerCity').val(userData.deliveryCity);
      $('#buyerName').val(userData.deliveryName);
      $('#buyerPhone').val(userData.deliveryPhone);
      $('#buyerZip').val(userData.deliveryZip);
    }

  });

});

$(document).ready(function(){
  $('.btnGoBack').on('click', function () {
    goBack();

  });
  function goBack() {
    window.history.back();
  }
});

$(document).ready(function () {
  $('#btnPayOut').attr('disabled', 'disabled');

  if(screen.width < 769) {
    $('#mobileData').val(true);
  }

  $('.js-potvrdi').click(function (e) {
    e.preventDefault();
    $.ajax({
      method: 'POST',
      url: ECOMMERCE_CART.save_url,
      success: function (data) {
        data = JSON.parse(data);
        $('.izmeni-link').remove();
        $('.js-potvrdi').text('Potvrđeno');
        $('.js-potvrdi').attr('disabled', 'disabled');
        $('input[name="customParam_buyer-transaction-id"]').attr('value',data.order.unique_transaction_id);
        $('input[name="chargetotal"]').attr('value',data.order.sum);
        $('input[name="shipping"]').attr('value',data.order.delivery_price);
        $('input[name="subtotal"]').attr('value',data.order.sum - data.order.delivery_price);

        $('input[name="oid"]').attr('value', data.order.id);
        $('#main-form').attr('action', data.url);
        $('#btnPayOut').removeAttr('disabled');
      }
    })
  });

});

